export const isLocaleLandingRoute = (pathname: string) =>
  /^\/[^/]+\/[^/]+\/?$/.test(pathname);
